import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { addAllList } from 'modules/common';
import { mediaSizeCode } from 'lib/api/code';

import MbSelectbox from 'components/molecules/MbSelectbox';

const SizeTypeFilter = ({ label, value, name, getParam, params, icon }) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [sizeTypeList, setSizeTypeList] = useState();

  useEffect(() => {
    mediaSizeCode()
      .then((response) => {
        const temporaryVar = addAllList(
          response.data.data,
          'CODE_DESC',
          'CODE_ID',
          'zero'
        );

        setSizeTypeList(temporaryVar);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  /**
   * 광고 상품에 대한 사이즈 리스트
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (name, index, value) => {
    let newParams;
    newParams = {
      ...params,
      [name]: value,
    };
    setIndex(index);
    getParam(newParams);
  };

  return (
    <MbSelectbox
      label={t('사이즈 형태')}
      name={'sizeType'}
      itemindex={index}
      optionData={sizeTypeList}
      optionLabelKey={'CODE_DESC'}
      optionValueKey={'CODE_ID'}
      handleOnchange={handleFilterChange}
      icon={false}
    />
  );
};

export default SizeTypeFilter;
